<template>
  <ZMainPage type="card" :loading="loading">
    <div class="z-box-bg mb-2">
      <div class="z-box-title">
        <span class="z-box-title-text">基础信息</span>
      </div>
      <LineWrapper list column="3" label-width="170rem">
        <LineItem v-for="item in list1" :key="item.label" :label="item.label">
          <span class="mr-1" v-if="item.value">{{ item.value }}</span>
          <span class="text-primary c-p" v-if="item.button" @click="handlePreview(item.type)">{{ item.button }}</span>
        </LineItem>
        <image-viewer :visible.sync="imageVisible" :list="[score_image]" />
      </LineWrapper>
    </div>
    <div class="z-box-bg mb-2">
      <div class="z-box-title">
        <span class="z-box-title-text mr-2">缴费详情</span>
        <template v-if="tag.length">
          <ZuTips v-if="item.name" :value="item.name" :type="item.type === 1 ? 'red' : 'orange'" v-for="(item, idx) in tag" :key="idx" />
        </template>
      </div>
      <LineWrapper list column="3" labelWidth="180rem">
        <LineItem class="item" v-for="item in list2" :key="item.label" :label="item.label" :value="item.value"></LineItem>
      </LineWrapper>
      <div class="table-wrap">
        <CustomTable :data="data" :config="config" type="orange" emptySrc="/img/data-o.png" :radius="true" @action="handleAction" />
      </div>
    </div>
    <Dialog :visible.sync="dialogVisible" :title="title" size="big" :showFooter="false">
      <template v-if="dialogType === 1">
        <LineWrapper list column="3">
          <LineItem :label="item.label" :value="item.value" v-for="item in dialogList" :key="item.label"></LineItem>
        </LineWrapper>
        <div class="pb-2"></div>
        <CustomTable :data="dialogListData1" :config="dialogListConfig1" headerBgColor="#CBE4FF" titleBgColor="#CBE4FF" headerColor="#333" :radius="false"></CustomTable>
        <CustomTable v-if="dialogListData2.length" :data="dialogListData2" :config="dialogListConfig2" headerBgColor="#CBE4FF" titleBgColor="#CBE4FF" headerColor="#333" :radius="false"></CustomTable>
      </template>
      <template v-else-if="dialogType === 2">
        <CustomTable border :data="dialogListData3" :config="dialogListConfig3"></CustomTable>
      </template>
    </Dialog>
    <Dialog :visible.sync="approveVisible" :loading="approveLoading" title="审批" size="large" buttonAlign="center" :closeOnClickModal="false" :beforeClose="onBeforeClose">
      <el-form :model="formData" :rules="rules" ref="ruleForm" label-width="130rem" label-position="left">
        <el-row>
          <el-col span="24">
            <el-form-item label="订单状态"><span style="color: #F53F3F;">{{ status_text }}</span></el-form-item>
          </el-col>
          <el-col span="8">
            <el-form-item label="分期项">{{ category_name }}</el-form-item>
          </el-col>
          <el-col span="8">
            <el-form-item label="本期应缴金额">{{ money_answer }}</el-form-item>
          </el-col>
          <el-col span="8">
            <el-form-item label="是否再次分期" prop="is_by_stages_again">
              <el-select v-model="formData.is_by_stages_again" placeholder="请选择是否分期" @change="onStageChange">
                <el-option label="否" :value="0"></el-option>
                <el-option label="是" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <template v-if="formData.is_by_stages_again">
            <el-col span="8">
              <el-form-item style="margin-bottom: 0;"></el-form-item>
              <el-form-item label="本期实缴金额" prop="money_actual">
                <el-input v-model="formData.money_actual" placeholder="请输入" :maxlength="30" @change="onAmountChange"></el-input>
              </el-form-item>
            </el-col>
            <el-col span="8">
              <el-form-item style="margin-bottom: 0;"></el-form-item>
              <el-form-item label="欠缴金额" prop="money_to_pay">
                <el-input v-model="formData.money_to_pay" disabled placeholder="请输入本期实缴金额"></el-input>
              </el-form-item>
            </el-col>
          </template>
          <template v-else>
            <el-col span="8">
              <el-form-item label="本期实缴金额">{{ money_answer }}</el-form-item>
            </el-col>
          </template>
          <el-col span="8">
            <el-form-item label="缴费时间" prop="pay_time">
              <el-date-picker v-model="formData.pay_time" type="datetime" placeholder="请选择缴费时间" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="实缴金额及方式" class="z-no-margin-bottom mb-2">
          <div class="z-dynamic-list-item" v-for="(domain, index) in formData.payment_detail" :key="domain.id">
            <div class="flex z-dynamic-list-inner">
              <el-form-item labelWidth="0" :prop="`payment_detail.${index}.paid_amount`" :rules="dynamicNumber">
                <el-input v-model="domain.paid_amount" placeholder="请输入学生缴费金额"></el-input>
              </el-form-item>
              <div class="px-2 text-gray">-</div>
              <el-form-item labelWidth="0" :prop="`payment_detail.${index}.payment_method`" :rules="dynamicSelect">
                <el-select v-model="domain.payment_method" placeholder="请选择学生缴费方式">
                  <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <div class="px-2 text-gray">-</div>
              <el-form-item labelWidth="0" :prop="`payment_detail.${index}.payer`" :rules="dynamicInput">
                <el-input v-model="domain.payer" placeholder="请输入付款人姓名" maxlength="20"></el-input>
              </el-form-item>
            </div>
            <el-form-item label-width="40rem">
              <el-button icon="el-icon-delete" circle v-if="formData.payment_detail.length !== 1" @click.prevent="handelRemove(domain)"></el-button>
              <el-button icon="el-icon-plus" circle v-if="formData.payment_detail.length !== dynamicMaxlength && index === formData.payment_detail.length - 1" @click="handleAdd"></el-button>
            </el-form-item>
          </div>
          <ZuTips :value="sumAmount" type="info" showIcon />
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" v-model="formData.reason" placeholder="请输入" :maxlength="300" show-word-limit :autosize="{ minRows: 8, maxRows: 20}"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button type="primary" @click="submit('ruleForm')">通过</el-button>
        <el-button type="warning" @click="submit('ruleForm', false)">暂存</el-button>
        <el-button @click="onClose">关闭</el-button>
      </template>
    </Dialog>
    <Dialog :visible.sync="viewVisible" title="查看" size="large" buttonAlign="center">
      <LineWrapper list column="3" label-width="130rem">
        <LineItem v-for="item in viewList1" :key="item.label" :label="item.label" :value="item.value" :cssStyle="item.cssStyle" :color="item.color"></LineItem>
      </LineWrapper>
      <template v-if="viewData.length">
        <LineWrapper list column="3" labelWidth="130rem">
          <LineItem label="实缴金额及方式">
            <div style="width: 700rem;">
              <CustomTable :data="viewData" :config="viewConfig" type="gray" />
              <ZuTips class="mt-2" :value="viewSumAmount" type="info" showIcon />
            </div>
          </LineItem>
        </LineWrapper>
        <LineWrapper list labelWidth="130rem">
          <LineItem label="备注" v-for="item in viewList2" :key="item.label" :label="item.label" :value="item.value" :cssStyle="item.cssStyle"></LineItem>
        </LineWrapper>
        <div class="mt-3 pb-2" style="border-top: solid 1rem #F2F2F2;"></div>
        <LineWrapper list column="3">
          <LineItem class="item" v-for="item in viewList3" :key="item.label" :label="item.label" :value="item.value" :cssStyle="item.cssStyle"></LineItem>
        </LineWrapper>
      </template>
      <template #footer>
        <el-button @click="viewVisible = false">关闭</el-button>
      </template>
    </Dialog>
    <template #footer>
      <el-button :disabled="loading" @click="$router.back()">返回</el-button>
    </template>
  </ZMainPage>
</template>

<script>
import LineWrapper from '@/components/common/LineWrapper'
import LineItem from '@/components/common/LineItem'
import ImageViewer from '@/components/common/ImageViewer'
import Dialog from '@/components/common/Dialog'
import CustomTable from "@/components/common/CustomTable"
import ZuTips from "@/components/common/ZuTips"
import ZuSpecialTable from "@/views/finance/enrollment/offline-payment-approval/components/ZuSpecialTable"
import ZuInstallmentTable from "@/views/finance/enrollment/offline-payment-approval/components/ZuInstallmentTable"
import ZuEmpty from '@/components/common/ZuEmpty.vue'
import { formDataBackMixin } from '@/utils/mixins'
import { formatDate, preciseAdd, preciseSubtract, objectIsEmpty, numberToChinese } from '@/utils'
import { validateNumber, verifyIsNumber } from '@/utils/validate'
import { orderPayMethod } from '@/utils/data'
import http from '@/api'
export default {
  _config:{'route':{'path':'edit-old','meta':{'title':'审批'}}},
  components: { LineWrapper, LineItem, ImageViewer, Dialog, CustomTable, ZuTips, ZuSpecialTable, ZuInstallmentTable, ZuEmpty },
  mixins: [formDataBackMixin],
  data() {
    const validateS = (rule, value, callback) => {
      const v = verifyIsNumber(value, { empty: '请输入本期实缴金额', positive: true })
      if (v) return callback(new Error(v))
      let str = ''
      if (Number(value) >= Number(this.money_answer)) {
        str = '实缴金额需要小于应缴金额'
      }
      if (str) return callback(new Error(str))
      callback()
    }
    return {
      id: '',
      loading: false,
      score_image: '',
      imageVisible: false,
      dialogVisible: false,
      approveVisible: false,
      approveLoading: false,
      viewVisible: false,
      title: '',
      dialogType: 0,
      list1: [],
      list2: [],
      data: [],
      config: [],
      tag: [],
      dialogList: [],
      dialogListData1: [],
      dialogListConfig1: [],
      dialogListData2: [],
      dialogListConfig2: [],
      dialogListData3: [],
      dialogListConfig3: [],
      dynamicMaxlength: 15,
      money_answer: 0,
      status_text: '',
      category_name: '',
      info: {},
      formData: {
        is_by_stages_again: 0,
        money_actual: '',
        money_to_pay: '',
        pay_time: '',
        payment_detail: [],
        reason: ''
      },
      rules: {
        is_by_stages_again: [{ required: true, message: '请选择是否再次分期', trigger: 'change' }],
        money_actual: [{ required: true, validator: validateS, trigger: 'blur' }],
        money_to_pay: [{ required: true, message: '请输入本期实缴金额', trigger: 'blur' }],
        pay_time: [{ required: true, message: '请选择缴费时间', trigger: 'change' }]
      },
      dynamicSelect: { required: true, message: '请选择学生缴费方式', trigger: 'change' },
      dynamicInput: { required: true, message: '请输入付款人姓名', trigger: 'blur' },
      dynamicNumber: { required: true, validator: (_, value, callback) => validateNumber(value, callback, { min: 0, equalToMin: true, empty: '请输入学生缴费金额' }), trigger: 'blur' },
      viewList1: [],
      viewList2: [],
      viewList3: [],
      viewData: [],
      viewConfig: [],
      viewSumAmount: ''
    }
  },
  computed: {
    sumAmount() {
      const arr = this.formData.payment_detail.filter(i => i.paid_amount)
      const sum = arr.reduce((pre, cur) => preciseAdd(pre, Number(cur.paid_amount) || 0), 0)
      if (isNaN(sum)) {
        return '请输入数字'
      }
      return `累计实缴金额：${sum}`
    }
  },
  created() {
    this.getConfig()
    this.getData()
  },
  methods: {
    onStageChange(val) {
      if (val) {
        this.formData.money_actual = ''
        this.formData.money_to_pay = ''
      }
    },
    onAmountChange(val) {
      if (verifyIsNumber(val, { empty: '请输入本期实缴金额', positive: true })) {
        this.formData.money_to_pay = ''
        return
      }
      let v1 = Number(val)
      let v2 = Number(this.money_answer)
      if (v1 >= v2) {
        this.formData.money_to_pay = ''
        return
      }
      this.formData.money_to_pay = preciseSubtract(v2, v1)
    },
    handleAction(row) {
      const data = { order_id: row.order_id, detail_ids: row.detail_ids, installment_order_id: row.installment_order_id, installment_num: row.installment_num }
      this.loading = true
      http({ url: '/finance/installment-pay/order-approve-view', pre: 'zs' }, data).then(res => {
        if (row.action.type === 'view') {
          this.handleView(res)
        } else if (row.action.type === 'approval') {
          this.info = res
          this.handleApprove(res)
        }
      }).finally(() => this.loading = false)
    },
    handleApprove(res) {
      this.approveVisible = true
      this.money_answer = Number(res.money_answer)
      this.status_text = res.pay_status_txt
      this.category_name = `${res.category_name} (${res.installment_num}/${res.installment_count})`
      const payment_detail = res.payment_detail || []
      this.formData = {
        is_by_stages_again: res.is_by_stages_again,
        money_actual: Number(res.money_actual),
        money_to_pay: Number(res.money_to_pay),
        pay_time: formatDate().fullDateTime,
        payment_detail,
        reason: res.reason
      }
      if (!payment_detail.length) this.handleAdd()
      // this.$refs.form.resetFields()
    },
    handleView(res) {
      this.viewList1 = []
      this.viewList2 = []
      this.viewList3 = []
      this.viewData = []
      this.viewVisible = true

      const payment_detail = res.payment_detail || []
      let list1 = []
      if (payment_detail.length) {
        list1 = [
          { label: '订单状态', value: res.pay_status_txt , cssStyle: {'grid-column': '1 / -1' }, color: '#23C343' },
          { label: '分期项', value: `${res.category_name} (${res.installment_num}/${res.installment_count})` },
          { label: '本期应缴金额', value: res.money_actual },
          { label: '是否再次分期', value: res.is_by_stages_again ? '是' : '否' },
          { label: '本期实缴金额', value: res.money_actual },
          { label: '缴费时间', value: res.pay_time }
        ]
      } else {
        list1 = [
          { label: '订单状态', value: res.pay_status_txt , cssStyle: {'grid-column': '1 / -1' }, color: '#23C343' },
          { label: '分期项', value: `${res.category_name} (${res.installment_num}/${res.installment_count})` },
          { label: '本期应缴金额', value: res.money_actual },
          { label: '本期实缴金额', value: res.money_actual },
          { label: '支付方式', value: res.pay_mode_txt },
          { label: '付款人姓名', value: res.customer_name },
          { label: '支付时间', value: res.pay_time }
        ]
      }
      // 订单信息
      this.viewList1 = list1
      if (!payment_detail.length) return
      const list2 = []
      if (res.reason) {
        list2.push({ label: '备注', value: res.reason, cssStyle: {'grid-column': '1 / 3' } })
      }
      // 备注
      this.viewList2 = list2
      // 操作记录
      this.viewList3 = [
        { label: '操作人', value: res.approval_creator },
        { label: '操作时间', value: res.approval_at, cssStyle: {'grid-column': '2 / -1' }},
      ]
      // 实缴金额及方式
      this.viewConfig = [
        { prop: 'paid_amount', label: '学生缴费金额', type: 'other' },
        { prop: 'payment_method', label: '学生缴费方式', type: 'other' },
        { prop: 'payer', label: '付款人姓名', type: 'other' }
      ]
      this.viewData = res.payment_detail.map(i => {
        return {
          paid_amount: i.paid_amount,
          payment_method: i.payment_method,
          payer: i.payer
        }
      })
      const sum = this.viewData.reduce((pre, cur) => preciseAdd(pre, Number(cur.paid_amount) || 0), 0)
      this.viewSumAmount = `累计实缴金额：${sum}`
    },
    getConfig() {
      this.typeOptions = orderPayMethod()
    },
    getData() {
      const id = this.$route.query.id
      if (!id) return
      this.id = id
      this.loading = true
      http({ url: '/finance/installment-pay/order-view', pre: 'zs' }, { order_id: id }).then(res => {
        const { order_type, tag = [] } = res
        this.tag = tag
        const stageMap = ['不分期', '明细分期', '部分欠缴']
        const stage_name = stageMap[res.is_by_stages]
        if ([3, 100].includes(order_type)) {
          const list1 = [
            { label: '订单编号', value: res.order_number },
            { label: '入账学校', value: res.school },
            { label: '订单类型', value: res.order_type_name },
            { label: '学生姓名', value: res.student_name },
            { label: '学生身份证号/护照号', value: res.student_idcard },
            { label: '缴费学年', value: res.school_year },
            { label: '就读年级', value: res.grade_name },
            { label: '行政班', value: res.class_name },
            { label: '就读校区', value: res.studying_school_name }
          ]
          if (order_type === 100) {
            list1.push({ label: '购买服务名称/收费项名称', value: res.goods_pack_name })
          }
          const list2 = [
            { label: '实际应缴总额', value: res.money_answer_actual_total },
            { label: '实际支付总额', value: res.money_actual },
            { label: '分期方式', value: stage_name },
            { label: '欠缴总额', value: res.money_to_pay }
          ]
          this.list1 = list1
          this.list2 = list2
        } else if (order_type === 2) {
          const list1 = [
            { label: '订单编号', value: res.order_number },
            { label: '入账学校', value: res.school },
            { label: '购买服务名称', value: res.goods_pack_name },
            { label: '学生姓名', value: res.student_name },
            { label: '学生身份证号/护照号', value: res.student_idcard },
            { label: '报名年级', value: res.grade_name },
            { label: '学习方向', value: res.study_type_name },
            { label: '专业方向', value: res.major_name },
            { label: '当前客户归属招生老师', value: res.belong_teacher },
            { label: '是否参与预报名', value: res.is_pre_register, button: res.is_pre_register === '是' ? '查看详情' : '', type: 2 }
          ]
          if (res.is_pre_register === '是') {
            list1.push({ label: '预报名支付金额', value: res.pre_register_amount })
          }
          if (res.max_score_name === '中考') {
            list1.push({ label: '中考成绩折算后总分', value: res.max_score })
            list1.push({ label: '中考成绩截图', value: res.score_image ? '' : '-', button: res.score_image ? '查看成绩截图' : '', type: 0 })
            this.score_image = res.score_image
          } else {
            list1.push({ label: '最高诊断性考试折算后总分', value: res.max_score, button: '查看详情', type: 1 })
            this.dialogList = [
              { label: '学生姓名', value: res.student_name },
              { label: '学生参考城市', value: res.senior_city },
              { label: '考试名称', value: res.max_score_name },
              { label: '考试总分', value: res.junior_score },
              { label: '折算后考试总分', value: res.max_score }
            ]
            const options = [], arr = res.diagnose_score_list || [], l1 = arr[0]?.length
            if (l1) {
              for (let i = 0; i < l1; i++) {
                options.push({ label: arr[0][i], value: arr[1][i] })
              }
            }
            let l2 = options.length
            if (l2 > 3) {
              l2 = Math.ceil(l2 / 2)
            }
            const obj1 = {num: '分数'}, obj2 = {num: '分数'}, config1 = [{ label: '科目', prop: 'num', type: 'title' }], config2 = [{ label: '科目', prop: 'num', type: 'title' }]
            options.forEach((i, index) => {
              if (index < l2) {
                obj1[`k_${index}`] = i.value
                config1.push({ prop: `k_${index}`, label: i.label })
              } else {
                obj2[`k_${index}`] = i.value
                config2.push({ prop: `k_${index}`, label: i.label })
              }
            })
            this.dialogListData1 = [obj1]
            this.dialogListConfig1 = config1
            if (config2.length > 1) {
              const l3 = config1.length - config2.length
              if (l3 > 0) {
                for (let i = 0; i < l3; i++) {
                  config2.push({ prop: `z_${i}`, label: '' })
                }
              }
              this.dialogListData2 = [obj2]
              this.dialogListConfig2 = config2
            }
          }
          this.list1 = list1
          const pre_register = res.pre_register || []
          this.dialogListData3 = pre_register.map(i => ({
            order_number: i.order_number,
            belong_teacher_name: i.belong_teacher_name,
            money_answer: i.money_answer,
            money_actual: i.money_actual,
            pay_time: i.pay_time || '-'
          }))
          this.dialogListConfig3 = [
            { prop: 'order_number', label: '预报名订单号' },
            { prop: 'belong_teacher_name', label: '预报名客户归属人' },
            { prop: 'money_answer', label: '应缴金额' },
            { prop: 'money_actual', label: '实缴金额' },
            { prop: 'pay_time', label: '支付时间' }
          ]
          const list2 = [
            { label: '系统计算应缴总额', value: res.money_answer },
            { label: '特批优惠总额', value: res.money_offline_discount },
            { label: '分期方式', value: stage_name },
            { label: '实际应缴总额', value: res.money_answer_actual_total },
            { label: '实际支付总额', value: res.money_actual },
            { label: '欠缴总额', value: res.money_to_pay }
          ]
          this.list2 = list2
        }
        this.config = [
          { prop: 'plan', label: '缴费计划', width: 150 },
          { prop: 'name', label: '分期项' },
          { prop: 'order_number', label: '订单编号' },
          { prop: 'status', label: '订单状态' },
          { prop: 'answer_price', label: '应缴金额' },
          { prop: 'price', label: '实缴金额' },
          { prop: 'pay_time', label: '缴费时间' },
          { prop: 'action', label: '操作' }
        ]
        const arr1 = res.order_plan || [], arr2 = []
        const statusMap = {
          0: { status: '待支付', text: '', type: '' },
          1: { status: '已支付', text: '查看', type: 'view' },
          2: { status: '已取消', text: '', type: '' },
          101: { status: '待支付', text: '审批', type: 'approval', color: '#FF7231' },
        }
        arr1.map((o, x) => {
          const len = o.length
          return o.map((i, j) => {
            const sd = statusMap[i.pay_status]
            const obj = {
              id: i.id,
              order_id: i.order_id,
              detail_ids: i.detail_ids,
              installment_order_id: i.installment_order_id,
              installment_num: i.installment_num,
              order_number: i.installment_order_number,
              plan: numberToChinese(x+1, true)+'期',
              status: sd.status,
              name: `${i.category_name}(${i.installment_num}/${i.installment_count})`,
              answer_price: Number(i.answer_price),
              price: Number(i.price),
              pay_time: i.pay_time,
              action: sd,
              active: i.pay_status === 101 ? true : false
            }
            if (len > 1) {
              if (j === 0) {
                obj.rowspan = len
                obj.rowKey = 'plan'
              } else {
                obj.hide = 'plan'
              }
            }
            arr2.push(obj)
          })
        })
        const s1 = arr2.reduce((pre, cur) => preciseAdd(pre, Number(cur.answer_price) || 0), 0)
        const s2 = arr2.reduce((pre, cur) => preciseAdd(pre, Number(cur.price) || 0), 0)
        arr2.push({ plan: '合计', answer_price: s1, price: s2 })
        this.data = arr2
      }).finally(() => this.loading = false)
    },
    handlePreview(type) {
      if (type === 0) {
        this.imageVisible = true
      } else {
        const arr = {
          1: '最高诊断性考试成绩详情',
          2: '预报名订单'
        }
        this.title = arr[type]
        this.dialogVisible = true
        this.dialogType = type
      }
    },
    handleAdd() {
      if (this.dynamicMaxlength <= this.formData.payment_detail.length) {
        return this.$message.warning(`最多只能添加${this.dynamicMaxlength}条`);
      }
      this.formData.payment_detail.push({ id: Date.now(), payment_method:'', paid_amount: '', payer: '', isAdd: 1 })
    },
    handleDelete(item) {
      const index = this.formData.payment_detail.indexOf(item)
      if (!~index) return
      this.formData.payment_detail.splice(index, 1)
    },
    handelRemove(item) {
      const { id, ...other } = item
      if(objectIsEmpty(other, ['isAdd'])) return this.handleDelete(item)
      this.$confirm('此操作将删除该项, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: (action, _instance, done) => {
          if (action === 'confirm') this.handleDelete(item)
          done()
        }
      }).then(() => {
        this.$message({ type: 'success', message: `删除成功!` })
      })
    },
    onBeforeClose(done) {
      done()
      this.getData()
    },
    onClose() {
      this.approveVisible = false
      this.getData()
    },
    submit(formName, save = true) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const { is_by_stages_again } = this.formData
          const arr = this.formData.payment_detail.filter(i => i.paid_amount)
          const sum = arr.reduce((pre, cur) => preciseAdd(pre, Number(cur.paid_amount)), 0)
          const num = is_by_stages_again ? Number(this.formData.money_actual) : Number(this.money_answer)
          let msg = ''
          if (num !== sum) msg = `学生【实缴金额及方式】的累计实缴金额需等于【本期实缴金额】`
          if (msg) return this.$message.error({ message: msg, duration: 4000 })
          this.handleConfirm(save)
        }
      })
    },
    handleConfirm(save = true) {
      const id = this.$route.query.id
      const { payment_detail, money_to_pay, money_actual, is_by_stages_again, ...other } = this.formData
      const data = { ...this.info, ...other, id, is_by_stages_again }
      data.payment_detail = payment_detail.map(item => {
        const { isAdd, id, ...other } = item
        const obj = { ...other }
        return obj
      })
      const num = is_by_stages_again ? money_actual : this.money_answer
      data.money_actual = Number(num)
      if (is_by_stages_again) {
        data.money_to_pay = money_to_pay
      }
      const url = `/finance/installment-pay/order-approve-${save ? 'do' : 'cache'}`
      this.approveLoading = true
      http({ url, pre: 'zs', method: 'post'}, data).then(() => {
        this.approveLoading = false
        this.approveVisible = false
        this.getData()
      }).catch(() => this.approveLoading = false)
    }
  }
}
</script>

<style lang="scss" scoped>

.table-wrap {
  padding-top: 30rem;
  margin-top: 10rem;
  border-top: dashed 1rem #F09D12;
}
</style>
